/**
 * Tax Management Models
 * 세무 관리 타입 정의
 */

export interface TaxCategory {
  id: string;
  code: string;
  name: string;
  description?: string;
  keywords?: string[];
  is_active: boolean;
  sort_order: number;
}

export interface TaxExpense {
  id: string;
  date: string;
  vendor: string;
  amount: number;
  vat: number;
  total: number;
  category_id?: string;
  category_name?: string;
  memo?: string;
  source: string;
  card_last4?: string;
  created_at?: string;
}

export interface CreateExpenseRequest {
  date: string;
  vendor: string;
  amount: number;
  vat: number;
  total: number;
  category_id?: string;
  memo?: string;
  card_last4?: string;
}

export interface UpdateExpenseRequest {
  date?: string;
  vendor?: string;
  amount?: number;
  vat?: number;
  total?: number;
  category_id?: string;
  memo?: string;
  card_last4?: string;
}

export interface CsvUploadResult {
  inserted: number;
  skipped: number;
  errors: string[];
}

export interface CreateCategoryRequest {
  code: string;
  name: string;
  description?: string;
  keywords?: string[];
  sort_order?: number;
}

export interface UpdateCategoryRequest {
  name?: string;
  description?: string;
  keywords?: string[];
  is_active?: boolean;
  sort_order?: number;
}

// ============================================
// 매출
// ============================================

export interface TaxRevenue {
  id: string;
  date: string;
  client: string;
  description?: string;
  amount: number;
  vat: number;
  total: number;
  invoice_issued: boolean;
  memo?: string;
  created_at?: string;
}

export interface CreateRevenueRequest {
  date: string;
  client: string;
  description?: string;
  amount: number;
  vat: number;
  total: number;
  invoice_issued?: boolean;
  memo?: string;
}

export interface UpdateRevenueRequest {
  date?: string;
  client?: string;
  description?: string;
  amount?: number;
  vat?: number;
  total?: number;
  invoice_issued?: boolean;
  memo?: string;
}

// ============================================
// 세금계산서
// ============================================

export interface TaxInvoice {
  id: string;
  direction: string; // sales / purchase
  date: string;
  counterpart_name: string;
  business_number?: string;
  supply_amount: number;
  tax_amount: number;
  total: number;
  memo?: string;
  created_at?: string;
}

export interface CreateInvoiceRequest {
  direction: string;
  date: string;
  counterpart_name: string;
  business_number?: string;
  supply_amount: number;
  tax_amount: number;
  total: number;
  memo?: string;
}

export interface UpdateInvoiceRequest {
  direction?: string;
  date?: string;
  counterpart_name?: string;
  business_number?: string;
  supply_amount?: number;
  tax_amount?: number;
  total?: number;
  memo?: string;
}

// 세금계산서 방향 라벨
export const getDirectionLabel = (direction: string): string => {
  return direction === 'sales' ? '매출' : '매입';
};

export const getDirectionColor = (direction: string): string => {
  return direction === 'sales' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700';
};

// 금액 포맷 (원화)
export const formatKRW = (amount: number): string => {
  return new Intl.NumberFormat('ko-KR').format(amount) + '원';
};

// 소스 라벨
export const getSourceLabel = (source: string): string => {
  return source === 'csv' ? 'CSV' : '수동';
};
